"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spiritswap = void 0;
exports.spiritswap = {
    router: '0x16327E3FbDaCA3bcF7E38F5Af2599D2DDc33aE52',
    masterchef: '0x9083EA3756BDE6Ee6f27a6e996806FBD37F6F093',
};
